<template>
  <div :class="{ 'iframe-mode': isInIframe }">
    <v-toolbar flat color="white" class="elevation-1">
      <div class="inline-flex w-64">
        <v-select
          class="ml-2 pt-3"
          :items="orderBy"
          clearable
          :placeholder="$t('message.LicensesManager.orderBy')"
          item-text="label"
          item-value="value"
          v-model="columnSelected"
          @change="orderList()"
          solo
          flat
          data-vs-select="orderby"
        ></v-select>
        <button
          class="order-button"
          @click="pagination.descending = !pagination.descending"
        >
          <zt-icon
            :name="pagination.descending ? 'arrow-down-2' : 'arrow-up'"
            class="pt-2"
            :class="primaryTextClass"
          />
        </button>
      </div>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="state.resultsSpecialRequests"
      :expand="expand"
      item-key="id"
      class="elevation-1"
      :rows-per-page-items="[8, 15, 30]"
      :total-items="totalItems"
      :loading="loading"
      :no-data-text="$t('message.datatable.noDataText')"
    >
      <template v-slot:items="props">
        <tr @mouseover="selectItem(props.item.id)" @mouseleave="unSelectItem()">
         <td class="text-zt-base text-zt-dark-500">
            {{ props.item.name + ' ' + props.item.lastname }}
          </td>
          <td>
            <p class="text-zt-base font-bold" :class="primaryTextClass">
              {{ props.item.type }}
            </p>
            <p :class="setColorByStatus(props.item.statusID)">
              {{ getStatus(props.item) }}
            </p>
          </td>
          <td class="text-zt-base text-zt-dark-500">
            {{ getApprover(props.item) }}
          </td>
          
          <td class="text-zt-base text-zt-dark-500">
            {{ props.item.date_from }}
          </td>
          <td class="text-zt-base text-zt-dark-500">
            {{ props.item.date_to }}
          </td>
          <td class="text-zt-base text-zt-dark-500">
            {{ props.item.days }}
          </td>

        </tr>
      </template>
    
    </v-data-table>
    
  </div>
</template>

<script>
import Licenses from '@/apiClient/Licenses'
import { find } from 'lodash'

export default {
  inject: ['state', 'mutations'],
  props: {
    userSelected: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
            results: this.state.resultsSpecialRequests,
                  resultsTotal: this.state.totalSpecialRequests,
      licenses: Licenses,
      teamLicensesList: [],
      totalLicenses: null,
      loading: false,
      selectedItem: false,
      selectedItemId: '',
      columnSelected: '',
      orderBy: [
        {
          value: 'type',
          label: this.$t(
            'message.LincensesHistorySummaryComponent.labels.licenseType'
          )
        },
        {
          value: 'status',
          label: this.$t(
            'message.LincensesHistorySummaryComponent.labels.status'
          )
        },
        {
          value: 'date_from',
          label: this.$t(
            'message.LincensesHistorySummaryComponent.labels.startDate'
          )
        },
        {
          value: 'date_to',
          label: this.$t(
            'message.LincensesHistorySummaryComponent.labels.return'
          )
        },
        {
          value: 'days',
          label: this.$t('message.LincensesHistorySummaryComponent.labels.days')
        }
      ],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 8,
        sortBy: null,
        totalItems: this.totalLicenses
      },
      expand: false,
      headers: [
                { text: `${this.$t('message.LicensesManager.search.nameLastname')}`, align: 'left', sortable: false, value: 'nombre' },

        {
          text: `
            ${this.$t(
              'message.LincensesHistorySummaryComponent.labels.licenseType'
            )}/
            ${this.$t(
              'message.LincensesHistorySummaryComponent.labels.status'
            )}`,
          align: 'left',
          sortable: false,
          value: 'tipo_alias',
          class: ['column-header']
        },
        {
          text: this.$t(
            'message.LincensesHistorySummaryComponent.labels.approver'
          ),
          sortable: false,
          align: 'left',
          value: 'en_manos_de',
          class: ['column-header']
        },
       
        {
          text: this.$t(
            'message.LincensesHistorySummaryComponent.labels.startDate'
          ),
          sortable: false,
          align: 'left',
          value: 'fecha_desde',
          class: ['column-header']
        },
        {
          text: this.$t(
            'message.LincensesHistorySummaryComponent.labels.return'
          ),
          sortable: false,
          align: 'left',
          value: 'fecha_regreso',
          class: ['column-header']
        },
        {
          text: this.$t('message.LincensesHistorySummaryComponent.labels.days'),
          sortable: false,
          align: 'left',
          value: 'dias',
          class: ['column-header']
        }
      ],
      activeModal: false,
    }
  },
  created() {
    this.licenses = new Licenses()
        this.getSpecialRequestsManager()

  },
  computed: {
    isInIframe() {
      return this.$iframeMessages && this.$iframeMessages.isTokenValid();
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    },
    setColorByStatus() {
      return id => {
        const config = [
          { id: 2, fontColor: 'text-zt-warning' },
          { id: 3, fontColor: 'text-zt-warning' },
          { id: 4, fontColor: 'text-zt-warning' },
          { id: 5, fontColor: 'text-zt-success' },
          { id: 8, fontColor: 'text-zt-danger' },
          { id: 9, fontColor: 'text-zt-dark-400' },
          { id: 10, fontColor: 'text-zt-dark-400' }
        ]
        const response = find(config, { id })
        return response ? response.fontColor : 'text-zt-dark-400'
      }
    },
    hasVPI() {
      return this.$store.state.hasIntegrationSichernPeople
    },
    totalItems() {
      return this.state.totalSpecialRequests || 0;
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getSpecialRequestsManager()
      },
      deep: true
    },
    'state.updateData'(newVal, oldVal) {
      if (newVal) {
        this.pagination = {
          descending: true,
          page: 1,
          rowsPerPage: 8,
          sortBy: null,
          totalItems: this.totalLicenses
        }
        this.getSpecialRequestsManager()
        this.mutations.updateHistory(false)
      }
    }
  },
  methods: {
    openUploadFileModal(item) {
      this.selectedItemId = item.id
      let fakemetadata = {
        id: item.id,
        id_template: 1,
        json: {
          name: 'GEN',
          alias: 'Generico',
          files: [
            {
              hash: '',
              name: 'Generico',
              alias: 'Generico',
              order: 10,
              value: '',
              mimeType: '',
              mandatory: true
            }
          ],
          max_files: 20,
          min_files: 1,
          version_name: 'CE1',
          version_number: 1
        },
        name: 'CERTIFICADOS DE LICENCIAS'
      }
      this.mutations.setUploadFilesMetaData(fakemetadata)
      this.activeModal = !this.activeModal
    },
    updateList() {
      this.pagination = {
        descending: true,
        page: 1,
        rowsPerPage: 8,
        sortBy: null,
        totalItems: this.totalLicenses
      }
      this.loading = true
      this.getHistoryLicenses().finally(() => {
        this.loading = false
      })
    },
    customErrorMessges(error) {
      const err = error.response.data.response_v2
      const code =
        err.code === 'La licencia no puede comenzar un dia feriado.'
          ? '02101'
          : err.code
      const message = err.message
      const sichernPeopleErrorCodeRegex = /^SICHERN_PEOPLE_[A-Z_]*_ABSENCE_BAD_REQUEST$/g.test(
        code
      )
      const handledMessages = [
        'StatusNotAllowed',
        'ProcessedAbsenceExists',
        'AbsenceNotExists',
        'AbsenceStatusNotValidForOperation',
        'ErrorDeletingReviewStatus',
        'OnlyRejectedTheLastOpeningAbsence',
        'InvalidDateRange'
      ]
      if (
        sichernPeopleErrorCodeRegex &&
        handledMessages.some(x => x == message)
      ) {
        return `${code}_${message}`
      } else {
        return code
      }
    },
    getStatus(item) {
      if (
        item.statusID === '2' ||
        item.statusID === '3' ||
        item.statusID === '4'
      ) {
        return this.$t('message.LicensesHistoryComponent.statusPending')
      } else if (item.statusID === '9') {
        return this.$t('message.LicensesHistoryComponent.statusExpired')
      } else {
        return item.status
      }
    },
    getApprover(item) {
      if (item.statusID === '4') {
        return 'RRHH'
      } else {
        return item.approver
      }
    },
    getSpecialRequestsManager() {
      this.loading = true
      const { sortBy, page, rowsPerPage } = this.pagination
      this.licenses
        .getSpecialRequestsManager(this.userSelected, rowsPerPage, page, sortBy)
        .then(response => {
          this.state.resultsSpecialRequests = response.data.results.data
          this.state.totalSpecialRequests = response.data.pagination.total
          this.loading = false
        })
        .catch(err => {
          this.loading = false
        })
    },
    orderList() {
      this.pagination.sortBy = this.columnSelected
    },
    selectItem(item) {
      this.selectedItem = item
    },
    unSelectItem() {
      this.selectedItem = false
    },
  }
}
</script>

<style lang="scss" scoped>
.column-header {
  font-size: 0.875rem !important;
  color: #969696 !important;
}
.order-button {
  outline: none;
}
::v-deep table.v-table {
  thead th:first-child {
    padding: 0 0 0 14px;
  }
  tbody td:first-child {
    padding: 0 0 0 14px;
  }
}

.text-iframe-primary {
  color: #2694fc !important;
}

.iframe-mode {
  ::v-deep .v-progress-linear {
    // Background del progress bar
    .v-progress-linear__background.primary {
      background-color: rgba(38, 148, 252, 0.3) !important;
    }
    
    // Barras indeterminadas con clase primary
    .v-progress-linear__bar__indeterminate.long.primary,
    .v-progress-linear__bar__indeterminate.short.primary {
      background-color: #2694fc !important;
    }
    
    // Por si acaso, también sobrescribir sin la clase primary
    .v-progress-linear__bar__indeterminate {
      &.long, &.short {
        background-color: #2694fc !important;
      }
    }
    
    // Barra determinada
    .v-progress-linear__bar__determinate {
      background-color: #2694fc !important;
    }
  }

  // Fix para dropdown de paginación - solo la lista desplegable
  ::v-deep .v-datatable__actions {
    // Eliminar colores del input principal
    .v-select {
      .v-input__slot {
        color: inherit !important;
      }
      
      .v-select__selection {
        color: inherit !important;
      }
    }
  }
  
  // Estilos para zt-icon en toolbar
  ::v-deep .zt-icon {
    color: #2694fc !important;
  }
}

// Fix global para la lista desplegable del paginador - solo el ítem activo
::v-deep .v-menu__content {
  .v-list__tile--active {
    color: #2694fc !important;
    
    .primary--text {
      color: #2694fc !important;
    }
  }
}
</style>
